import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { Error } from './error/error';

@Component({
    selector: 'stby-errors',
    templateUrl: './errors.html',
    imports: [Error, TranslateModule],
})
export class Errors {
    readonly errors = input<string[]>([]);
}
